import { Capacitor } from '@capacitor/core';

/** True when the browser is real Safari (Sign in with Apple on the web is limited by Apple). */
export const isSafariWebBrowser = () => {
  if (typeof window === 'undefined') return false;
  const ua = String(window.navigator?.userAgent || '');
  const isSafari = /Safari/i.test(ua);
  const excluded = /(Chrome|CriOS|Edg|OPR|Opera|Firefox|FxiOS|SamsungBrowser)/i.test(ua);
  return isSafari && !excluded;
};

/**
 * Offer Apple sign-in only where it can work: native iOS (Firebase plugin) or Safari on the web.
 * Android native/web and Chrome/Firefox must not show Apple (per Apple + no native Android Apple auth here).
 */
export const canOfferAppleSignIn = () => {
  if (Capacitor.isNativePlatform()) {
    return Capacitor.getPlatform() === 'ios';
  }
  return isSafariWebBrowser();
};
